import React from 'react';
import { DatePicker as AntDatePicker } from 'antd';
import dayjs, { Dayjs } from 'dayjs';
import { Experience } from '../../../../../../context/dataExperienceContext';
import './styles.scss';
import { useDateAvailabilityAndConvert } from '../../availability-and-price-helpers';

interface DatePickerProps {
  promoterComission: number;
  availabilitySchedule: Experience['availabilitySchedule'];
  onDateSelect: (date: string) => void;
  selectedDate?: string;
}

const DatePicker: React.FC<DatePickerProps> = ({
  promoterComission,
  availabilitySchedule,
  onDateSelect,
  selectedDate,
}) => {

  // Function to handle date selection
  const handleSelect = (date: Dayjs | null) => {
    if (date) {
      onDateSelect(date.format('YYYY-MM-DD'));
    }
  };

  // Custom date cell renderer
  const DateRender = (currentDate: Dayjs) => {
    const availability = useDateAvailabilityAndConvert(currentDate, availabilitySchedule);
    const isPast = currentDate.isBefore(dayjs(), 'day');
    // Adding an extra day to the 3 days defined on API to cover gaps that may come from the service time and the browser time.
    const isNextFourDays = currentDate.isBefore(dayjs().add(5, 'day'), 'day');

    return (
      <div className={`custom-date-cell ${!availability.isAvailable || isPast || isNextFourDays ? 'disabled' : ''}`}>
        <div className="date-number">{currentDate.date()}</div>
        {availability.isAvailable && !isPast && !isNextFourDays && (
          <div className="date-price">
            {availability.code} {Math.round(availability.price)}
          </div>
        )}
      </div>
    );
  };

  return (
    <div className='datePicker__container'>
      <div className='input-datepicker'>
        <AntDatePicker
          className='input-datepicker__self'
          placeholder="dd/mm/aa"
          onChange={handleSelect}
          value={selectedDate ? dayjs(selectedDate) : null}
          dateRender={DateRender}
        />
      </div>
    </div>

  );
};

export default DatePicker;
